module.exports = __webpack_public_path__ + "static/img/title3.1610374.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/login/img/title3.png
// module id = Yk1j
// module chunks = 3